module.exports = __webpack_public_path__ + "static/img/15.953306b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/15.png
// module id = QiR9
// module chunks = 0